import { TravelCardsDto, UpdateTravelCardDto, TravelCardOrderDetailsDto, TravelCardDto } from '../../types';
import { AxiosResponse } from 'axios';

export const ITravelCardApiId = Symbol.for('ITravelCardApi');

export interface ITravelCardApi {
    /**
     * Get travel cards.
     * @param take
     */
    getTravelCards(take?: number): Promise<TravelCardsDto | undefined>;

    /**
     * Create travel cards.
     * @param name
     * @param id
     */
    createTravelCard(name: string, id: string): Promise<AxiosResponse<TravelCardDto>>;

    /**
     * Block travel card.
     * @param id
     */
    blockTravelCard(id: string): Promise<void>;

    /**
     * Update travel card.
     * @param id
     * @param name
     */
    updateTravelCard(id: string, name: string): Promise<UpdateTravelCardDto | undefined>;

    /**
     * Delete travel card.
     * @param id
     */
    deleteTravelCard(id: string): Promise<void>;

    /**
     * Get multiple travel card data from ticketing system
     * @param cardNumbers
     * @param language
     */
    getMultipleTravelCardData(cardNumbers: string, language: string): Promise<TravelCardOrderDetailsDto[] | undefined>;

    /**
     * Validate travel card data in ticketing system
     * @param cardNumber
     */
    validateTravelCardNumber(cardNumber: string): Promise<boolean>;
}
